// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__I9E0W","selected":"Tabs_selected__rYuNo","FULL":"Tabs_FULL__MwhB4","guide":"Tabs_guide__eOqfi","enableTransition":"Tabs_enableTransition__fC99R"};